export default class BasketPromocode {
  constructor (data) {
    if (!data || !data.number) throw new Error('Wrong BasketPromocode data')

    this.number = data.number
    this.isValid = data.can_be_applied
    this.message = data.message
  }
}
